<template>
  <div>
    <h4 class="mt-4 mb-4">Zoek Resultaat</h4>
    <v-card>
      <v-list two-line class="notificationList_osm">
        <template v-for="(location, index) in searchedLocations">
          <v-list-tile :key="index">
            <v-layout row wrap>
              <v-flex xs8>
                <v-subheader color="black" class="listTitle">{{ location.name }}</v-subheader>
                <v-subheader
                  v-if="location.openingHours!=''"
                  color="black"
                  class="listTitle2"
                >{{ location.openingHours }}</v-subheader>
              </v-flex>
              <v-flex xs2>
                <v-list-tile-action>
                  <v-tooltip bottom>
                    <v-btn
                      round
                      small
                      slot="activator"
                      color="primary"
                      @click="showSearchedLocations(location)"
                    >
                      <!-- <v-list-tile-action-text style="color:white"></v-list-tile-action-text> -->
                      <v-icon>play_arrow</v-icon>
                    </v-btn>
                    <span>Selecteer</span>
                  </v-tooltip>
                </v-list-tile-action>
              </v-flex>
            </v-layout>
          </v-list-tile>
          <v-divider v-if="index + 1 < searchedLocations.length" :key="`divider-${index}`"></v-divider>
        </template>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import RelationAspect from "../aspects/RelationAspect";
import BaseRadiusPointAspect from "../aspects/BaseRadiusPointAspect";

export default {
  name: "OsmResult",
  props: {
    searchedLocations: Array,
    type: String
  },
  watch: {
    type: function(next, from) {
      this.aspectType = next;
    }
  },
  data() {
    return {
      aspectType: this.type
    };
  },
  created() {
  },
  methods: {
    showSearchedLocations(locationSource) {
      //TODO: Show searched location in another colour and plot green when its actually created
      let location = JSON.parse(JSON.stringify(locationSource));
      let locationId = 0;
      let genericAspect = {};
      let data = {
        relationId: locationId++,
        coordinates: "",
        parentId: "",
        state: 3,
        id: location.name,
        referenceName: location.name,
        position: [],
        showToolTip: true,
        type: "NEW_DESTINATION_POINT"
      };
      locationId++;
      data.coordinates = location.polyline;

      let tmp = location.polyline.split(" ");
      let newPolyline = "";
      tmp.forEach(i => {
        let h = i.split(",");
        newPolyline += h.reverse().join() + " ";
      });
      location.polyline = newPolyline;

      window.EventBus.fire("setSelectedLocation", location);
      switch (this.aspectType) {
        case "way":
          genericAspect = new RelationAspect(data);
          break;
        case "node":
        case "relation":
        default:
          data.position = [
            Number(location.longitude),
            Number(location.latitude)
          ];
          genericAspect = new BaseRadiusPointAspect(data);
          break;
      }
      genericAspect.set("type", "NEW_DESTINATION_POINT");

      window.EventBus.fire("moveToSelectedArea", {
        aspect: genericAspect,
        id: data.id,
        cleanLayer: true
      });

      window.EventBus.fire("moveToFeature2", genericAspect);
    }
  }
};
</script>

<style scoped lang="scss">
.notificationList_osm {
}
</style>
